import React, { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      
      // On iOS, set status bar to light style (light text) when modal opens
      // This looks better against the dark modal backdrop
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        StatusBar.setStyle({ style: Style.Light }).catch(() => {});
      }
    } else {
      document.body.style.overflow = 'auto';
      
      // Restore status bar style based on system preference
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        StatusBar.setStyle({ 
          style: prefersDark ? Style.Light : Style.Dark 
        }).catch(() => {});
      }
    }

    return () => {
      document.body.style.overflow = 'auto';
      // Restore status bar on unmount
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        StatusBar.setStyle({ 
          style: prefersDark ? Style.Light : Style.Dark 
        }).catch(() => {});
      }
    };
  }, [isOpen]);

  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          className="modal-close" 
          onClick={onClose}
          aria-label="Close modal"
        >
          <X size={20} />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
